export default [
  { label: 'Template #1', value: 'SignatureTemplate1' },
  { label: 'Template #2', value: 'SignatureTemplate2' },
  { label: 'Template #3', value: 'SignatureTemplate3' },
  { label: 'Template #4', value: 'SignatureTemplate4' }
]
